import { NAME } from './constants';
import { apiProvider } from './api';

export const GDPR = {
	name: NAME,
	apiProvider,
};
